import Head from 'next/head';

import ResetPassword from '../../../components/Auth/ResetPassword';
import { pageTitle } from '../../../components/shared/basic/customHead';

const ResetPasswordPage = () => {
  return (
    <div className=''>
      <Head>
        <title>{pageTitle('Reset Password')}</title>
      </Head>
      <ResetPassword />
    </div>
  );
};
export default ResetPasswordPage;
